<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">

        </div>
        <!-- CONTENT CARD -->
        <div class="content-card">
            <img src="./assets/images/norm35/Mesa de trabajo 5.png" alt="Logo-Norm35" class="centradoIMG ">
        </div>
    </div>
    <div class="content-card center" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
        <p>A continuación encontrarás un listado con los lineamientos que la Norma 035 considera necesarios a llevar a cabo por parte de la empresa.</p><br>
        <p>Los siguientes aspectos están documentados en esta sección:</p>
        <div class="container">
            <div *ngFor="let datita of dataLink">
                <p>
                    <a target="_blank" href="./NOM35/wizard/{{datita.ruta}}">{{datita.name}}</a>
                </p>
                <div *ngFor="let subdatita of dataSubLink">
                    <ul *ngIf=" datita.idLink == subdatita.idSubLink ">
                        <a target="_blank" href="./NOM35/wizard/{{subdatita.ruta}}">{{subdatita.name}}</a>
                    </ul>
                </div>
            </div>
        </div><br><br><br>

    </div>
</div>
